import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { OpenVideoIcon } from '/src/components';
import defaultClasses from './resourcesContent.module.css';
import Video from '../../lib/Video/video';
import VideoPreviewModal from './videoPreviewModal';

var ResourcesVideoItem = function ResourcesVideoItem(_ref) {
  var _item$url;

  var item = _ref.item;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentVideo = _useState2[0],
      setCurrentVideo = _useState2[1];

  useEffect(function () {
    if (currentVideo) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
    }
  }, [currentVideo]);

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 640;
  var splitUrl = (_item$url = item.url) === null || _item$url === void 0 ? void 0 : _item$url.split('?');
  var searchParams = new URLSearchParams(splitUrl === null || splitUrl === void 0 ? void 0 : splitUrl[1]);
  searchParams.set('controls', 0);
  var searchParamsUrl = (splitUrl === null || splitUrl === void 0 ? void 0 : splitUrl[0]) + '?' + (searchParams === null || searchParams === void 0 ? void 0 : searchParams.toString());

  var handleToggleVideo = function handleToggleVideo(item) {
    return setCurrentVideo(item);
  };

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "col-span-9"
  }, React.createElement("div", {
    className: "grid grid-cols-12 py-4 border-b border-solid border-snowbound items-center sm_py-3 sm_grid-cols-9"
  }, React.createElement("div", {
    className: "col-span-12 sm_col-span-6 flex items-center cursor-pointer"
  }, !isSmallDevice && React.createElement("div", {
    className: defaultClasses.videoWrapper,
    onClick: function onClick() {
      return handleToggleVideo(item);
    }
  }, React.createElement(Video, {
    url: searchParamsUrl,
    resourceName: item.file_name,
    classes: {
      container: 'p-0'
    }
  })), React.createElement("div", {
    className: "pb-2 underline sm_no-underline sm_pb-0 sm_ml-2 cursor-pointer",
    onClick: function onClick() {
      return handleToggleVideo(item);
    },
    role: "button"
  }, item.file_name)), !isSmallDevice && React.createElement("div", {
    className: defaultClasses.hoverIcon
  }, React.createElement("div", {
    onClick: function onClick() {
      return handleToggleVideo(item);
    },
    role: "button"
  }, React.createElement(OpenVideoIcon, null))), React.createElement("div", {
    className: "col-span-2 sm_col-span-1 sm_text-center"
  }, item.file_size), React.createElement("div", {
    className: "col-start-10 col-span-3 text-right sm_col-span-1 sm_text-center"
  }, item.date))), currentVideo && React.createElement(VideoPreviewModal, {
    isOpen: currentVideo,
    toggleVideoModal: function toggleVideoModal() {
      return setCurrentVideo(null);
    },
    item: currentVideo,
    resourceName: item.file_name
  }));
};

export default ResourcesVideoItem;